import React, { useState, useEffect, useContext } from "react";
import { Alert, Box, Grid, TextField, Typography, Button, Paper, Checkbox, FormControlLabel, Tooltip } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Switch from '@mui/material/Switch';
import FormControl from '@mui/material/FormControl';
import FormGroup from "@mui/material/FormGroup";
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import successIcon from '../assets/payment-success-icon.png';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { useMember } from '../context/MemberProfileContext';

import PaymentComp from '../components/PaymentComp'
import { DataContext } from '../App';


export default function BalaviharRegistration() {
    
    const [tempData, setTempData] = useState({
        "membershipType": "",
        "membershipGeneralAdmissionFee": 0,
        "membershipParivarNoBalaviharFee": 0,
        "membershipParivarMemberFee": 0,
        "membershipSingleChildFee": 0,
        "membershipTwoPlusChildFee": 0,
        "membershipTypeName": "",
    });
    const [membershipData, setMembershipData] = useState({
        "balaviharYear": "",
        "status": "",
        "membershipType": {
            "name": ""
            },
        "currentMembership": {
            "notes": "First time registering"
        },
        
        "currentTransaction": {
            "quantities": "1",
            "itemPrice": "",
            "donationAmount": "0",
            "totalAmount": "",
            "payerId": "",
            "notes": "before checkout"
        },
        "registeredSessions": [
            {
                "notes": "",
                "memberEntity": {
                    "firstName": "",
                    "lastName": ""
                },
                "sessionEntity": {
                    "sessionName": ""
                },
                "gradeEntity": {
                    "grade": ""
                }
            }]
        });

        function loadMembershipData() {
            //membershipData.balaviharYear = memberships.currentMembership.transactionEntity.eventTypesEntity.eventYear;
            membershipData.balaviharYear = memberships.balaviharYear;
            membershipData.currentTransaction.quantities = noOfPeople;
            membershipData.currentTransaction.itemPrice = ticketPrice;
            membershipData.currentTransaction.donationAmount = donation;
            membershipData.currentTransaction.totalAmount = totalAmount;

              // Populate registeredSessions array from studentFields
            membershipData.registeredSessions = studentFields.map((student) => ({
                notes: "",
                memberEntity: {
                firstName: student.firstName,
                lastName: student.lastName,
                },
                sessionEntity: {
                sessionName: student.session,
                },
                gradeEntity: {
                grade: student.grade,
                },
            }));
            if (parivarMember) { //
                membershipData.membershipType.name = "Chinmaya Parivar Member";    
                };
            console.log("Membership Data after Database call :", membershipData);      
    
            };
   


    const [eventData, setEventData] = useState({
        parent: {
            memberType: "parent",
            firstName: "",
            lastName: "",
            mobileNumber: "",
            email: "",
            gender: "",
            age: 5,
            grade: "",
            tshirtSize: "",
            streetAddress: "",
            city: "",
            state: "",
            postalCode: "",
            allergies: "",
            notes: "",
            childCareReqd: "",
            volunteer: ""
        },
        spouse: {
            memberType: "spouse",
            firstName: "",
            lastName: "",
            mobileNumber: "",
            email: "",
            gender: "",
            age: 0,
            grade: "",
            streetAddress: "",
            city: "",
            state: "",
            postalCode: "",
            allergies: "",
            notes: "",
            childCareReqd: "",
            volunteer: ""
        },
        children: [{
            memberType: "child",
            firstName: "",
            lastName: "",
            fullName: "",
            grade: "",
            session: ""
        }],
        guest: [],
        transaction: {
            quantities: 1,
            itemPrice: 0,
            totalAmount: "",
            donationAmount: "",
            paymentStatus: "",
            payerId: ""
        },
        medical: {
            pcpName: "",
            pcpMobile: "",
            medicalInsurance: "",
            groupNo: "",
            idNo: "",
            medicalNotes: "",
            medicalConsentSignedBy: "",
            treatmentConsentSignedBy: ""
        },
        tshirts: [],
        eventType: 'BVRegistration',
        eventTypeId: 13,
        center: '',
        notes: '',
        sessionName: "",
        otherCenter: '',
        feeEnabled: 0,
        parivarEnabled: 0,
        success: false
    });
    //to populate registered children
    const { memberProfile, setMemberProfile } = useMember();
    
    //const [fullNames, setFullNames] = useState();
    const [fullNames, setFullNames] = useState(memberProfile.children.map((child) => child.fullName));
    const [sessions, setSessions] = useState();
    //const [grades, setGrades] = useState([]);
    const [grades, setGrades] = useState(['BV PRE-Kindergarten', 'BV Kindergarten', 'BV 1st Grade', 'BV 2nd Grade', 'BV 3rd Grade','BV 4th Grade', 'BV 5th Grade', 'BV 6th Grade', 'BV 7th Grade', 'BV 8th Grade', 'BV 9th Grade', 'BV 10th Grade', 'BV 11th Grade', 'BV 12th Grade']);
    const [gradeFlag, setGradeFlag] = useState(false);
    const [studentFields, setStudentFields] = useState([]);
    const [error, setError] = useState(null);
    const [childLimit, setChildLimit] = useState(4);
    
    const { accessToken, signOut } = useAuth();
    const [rulesAccepted, setRulesAccepted] = useState(false); // State to manage checkbox
    const API_URL = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const { memberships, setMemberships} = useMember();
    const [parivarMember, setParivarMember] = useState(false);
   
    
    const [ticketPrice, setTicketPrice] = useState(0);  
    const eventTypes = useContext(DataContext);
    console.log("Enter Balavihar Registration: ", accessToken);
    console.log("Enter Full Names, sessions, grades : ", fullNames, sessions, grades, memberProfile);

  useEffect(() => {

    console.log("Token exists or not :", accessToken);

    if (accessToken) {
        console.log("Token exists or not test:", accessToken);       
        memberProfileFetch(); // Load membership data
        console.log("Temp data :", tempData);
    } else {
        signOut();
        navigate('/');
    }
  }, [accessToken])         // Empty dependency array ensures this runs once on mount;

  useEffect(() => {
    console.log("inside membership changes :");

      if (memberships && memberships.membershipTypes && memberships.membershipTypes.length > 0) {
          loadMembershipFeeData(); // Load membership fee data
          setSessions(memberships.availableSessions.map((child) => child.sessionName));

       // Set childLimit based on childQuantities for specific membership types
       /* const membershipType = memberships.membershipTypes.find(type => type.name === 'Chinmaya Parivar Member' || type.name === 'Balavihar (2+ Children)');
        if (membershipType) {
            setChildLimit(membershipType.childQuantities || 0);
        }  */        
      }  
     
    if (memberships.registeredSessions && memberships.registeredSessions.length > 0) {
        setStudentFields(memberships.registeredSessions.map((session) => ({
            memberType: "child",
            firstName: session.memberEntity.firstName,
            lastName: session.memberEntity.lastName,
            fullName: session.memberEntity.fullName,
            session: session.sessionEntity.sessionName,
            grade: session.gradeEntity.grade,
            gradeFlag: true
        })));
        setNoOfPeople(memberships.registeredSessions.length);
    }
    if ((memberships.status === "ACTIVE") && (memberships.currentMembership.membershipTypesEntity.name === "Chinmaya Parivar Member")) 
        {
        setParivarMember(true);
        };
    console.log("inside loading student fields :" , studentFields);

  }, [memberships]);

 
    useEffect(() => {
        eventData.parent.firstName = memberProfile.primary.firstName;
        eventData.parent.lastName = memberProfile.primary.lastName;
        eventData.parent.email = memberProfile.primary.email;
        eventData.parent.mobileNumber = memberProfile.primary.mobileNumber.replace(/[-\s]/g, ''); // Remove hyphens and spaces    
    }, [])         // Empty dependency array ensures this runs once on mount

    //console.log("Ticket price :", ticketPrice);
    console.log("Membershipdata, Temp and student data :", membershipData, tempData, studentFields);

    const [inputFields, setInputFields] = useState(eventData.transaction);
        const [feeEnabled, setFeeEnabled] = useState(0);
    const [parivarEnabled, setParivarEnabled] = useState(0);

    const [donation, setDonation] = useState(0);
    const [totalAmount, setTotalAmount] = useState(inputFields.quantities * inputFields.itemPrice);
    const [noOfPeople, setNoOfPeople] = useState(0);
    console.log("Event data in Student handle form :", (studentFields), noOfPeople, memberships.totalAmountPaid);        
 
    const total = () => {
        inputFields.donationAmount = donation;
        inputFields.totalAmount = totalAmount;
        eventData.transaction = inputFields;
    }
    total();
    
    useEffect(() => {
        //eventData.transaction.quantities = noOfPeople;
        // When the user switches between membership types, reset the student fields
        if (tempData.membershipType === "GeneralAdmission") {
            setStudentFields([]);
            //membershipData.registeredSessions = ([]);
            setNoOfPeople(0);
        }
        if ((tempData.membershipType === "Balavihar") && (noOfPeople === 0)) {
            setTicketPrice(0); // Reset ticket price when switching between membership types
        }
        
        if (noOfPeople === 1) { 
            setTicketPrice(tempData.membershipSingleChildFee - memberships.totalAmountPaid);
            membershipData.membershipType.name = "Balavihar (Single Child)";} 
        if (noOfPeople >= 2) {
            setTicketPrice(tempData.membershipTwoPlusChildFee - memberships.totalAmountPaid);
            membershipData.membershipType.name = "Balavihar (2+ Children)";};
        if (tempData.membershipType === "GeneralAdmission" || (memberships.status === "ACTIVE" && noOfPeople === 0)) {
            setTicketPrice(tempData.membershipGeneralAdmissionFee - memberships.totalAmountPaid);
            membershipData.membershipType.name = "General Member (NO Balavihar)";}
        if (parivarEnabled || parivarMember) {
            setTicketPrice(tempData.membershipParivarMemberFee - memberships.totalAmountPaid);
            if (tempData.membershipType === "Balavihar" || memberships.status === "ACTIVE" ) {
                setTicketPrice(tempData.membershipParivarMemberFee - memberships.totalAmountPaid);
                membershipData.membershipType.name = "Chinmaya Parivar Member";
            }
            if (tempData.membershipType === "GeneralAdmission" || memberships.status === "ACTIVE" ) {
                setTicketPrice(tempData.membershipParivarNoBalaviharFee - memberships.totalAmountPaid);
                //membershipData.membershipType.name = "Chinmaya Parivar (NO Balavihar)";
                membershipData.membershipType.name = "Chinmaya Parivar Member";
            }
        }
        eventData.transaction.itemPrice = ticketPrice;
        if (feeEnabled) {
            setTotalAmount(((parseInt(ticketPrice) + parseInt(donation)) * 1.03).toFixed(2));
        } else {
            setTotalAmount((parseInt(ticketPrice) + parseInt(donation)) * 1.00);
        }

        eventData.transaction.totalAmount = totalAmount;
    }, [noOfPeople, donation, feeEnabled, parivarEnabled, tempData.membershipType, ticketPrice])

    const handleSessionChange = (e, index) => {
        console.log("Handle session change :", e.target.name, e.target.value, (studentFields));        

        let newForm = [...studentFields];
        newForm[index][e.target.name] = e.target.value;
        //newForm[index].gradeFlag = true;
        setStudentFields(newForm);
        const selectedSession = memberships.availableSessions.find((session) => session.sessionName === e.target.value);
        setGrades(selectedSession ? selectedSession.grades.map((grade) => grade.grade) : []);  
        setGradeFlag(true); // Enable grade selection        
    }

    const handleStudentChange = (e, index) => {
        //console.log("Event data in Student handle form :", (studentFields));        
        let newForm = [...studentFields];
        newForm[index][e.target.name] = e.target.value;
        const selectedChild = memberProfile.children.find((child) => child.fullName === e.target.value);
        if (selectedChild) { // Populate the child's details
            newForm[index].firstName = selectedChild.firstName;
            newForm[index].lastName = selectedChild.lastName;
        }
        setStudentFields(newForm);
        eventData.children = newForm;
    }
    // Populate the full names of the available children
    const getAvailableChildren = (index) => {
        const selectedChildren = studentFields.map((student) => student.fullName);
        return fullNames.filter((name) => !selectedChildren.includes(name) || studentFields[index].fullName === name);
    }
    const handleAddFields = () => {
        //console.log("Handle add fileds", fullNames.length, noOfPeople, childLimit, fullNames.length - 1);
        if (noOfPeople >= fullNames.length) {
            console.log("No children available to add. Please add children in the profile screen to proceed.");
            setError("No children available to add. Please add children in the profile screen to proceed or Checkout to complete the registration.");
        return;
        }
        if (noOfPeople >= childLimit) {
            setError("Children registration limit reached. Please reach out to membership support to enroll more than 4 children or Checkout to complete the registration.");
        return;
        }   

        setStudentFields([...studentFields, {
            memberType: "child", firstName: "", lastName: "", fullName: "", session: "", grade: ""
        }]);
        setNoOfPeople(noOfPeople + 1);
        //c1 setGradeFlag(false);        
    };

    const handleRemoveFields = (index) => {
        const values = [...studentFields];
        values.splice(index, 1);
        setStudentFields(values);
        eventData.children = values;
        setNoOfPeople(noOfPeople - 1);
    };

    const handleLogout = () => {
        signOut();
        navigate('/');
      };

    const memberProfileFetch = async () => {
        console.log("Token value B", accessToken);
        let response, data;
        try {    
          //const response = await fetch('https://membership.cmdfw.org/api/gquery', {
          const response = await fetch(`${API_URL}/gquery`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-cmdfw-jwt-token': `${accessToken}`,
            },
              body: JSON.stringify({
                  query: `
                          query {
                            memberships {
                                balaviharYear
                                balaviharPeriod
                                status
                                totalAmountPaid
                                membershipTypes {
                                    membershipTypeId
                                    name
                                    startDate
                                    endDate
                                    bvPrice
                                    childQuantities
                                }
                                availableSessions {
                                    sessionId
                                    center
                                    sessionName
                                    grades {
                                        gradeId
                                        grade
                                    }
                                }
                                registeredSessions{
                                    bvRegistrationId
                                    regStartDate
                                    regEndDate
                                    status
                                    memberEntity{
                                        firstName
                                        lastName
                                        fullName
                                    }
                                    sessionEntity {
                                        sessionId
                                        center
                                        sessionName
                                    }
                                    gradeEntity{
                                        gradeId
                                        grade
                                    }
                                }
                                currentMembership {
                                    membershipId
                                    startDate
                                    endDate
                                    status
                                    notes
                                    bvYear
                                    createdAt 
                                    createdBy 
                                    membershipTypesEntity{
                                        membershipTypeId
                                        name
                                        startDate
                                        endDate
                                    }
                                    transactionEntity {
                                        transactionId
                                        eventTypesEntity {
                                            eventTypeId
                                            name
                                            eventYear
                                        }
                                        totalAmount
                                        paymentStatus
                                        createdAt 
                                        createdBy 
                                    }
                                }
                            }
                          }
                        `,
            }),
          });
    
          const data = await response.json();
          if (response.ok) {
            setMemberships(data.data.memberships);
            console.log("Membership data after API call:", data, response);
          } else {
            if (response.status === 403) {
              const errorData = await response.json();
              handleLogout(); // Logout user
              throw new Error(errorData.message || 'OTP expired');
            } else {
              if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Membership fetch failed');
              }
            }
          }
        } catch (error) {
          console.error("Error fetching Membership Profile :", error);
          signOut();
          //navigate('/');
        }
      };
    function loadMembershipFeeData() {
        console.log("Membership Profile data to load fees  :", memberships);            

        memberships.membershipTypes.forEach((membershipType) => {
            if (membershipType.name === 'Chinmaya Parivar Member') {
                setTempData((prevData) => ({ ...prevData, membershipParivarMemberFee: membershipType.bvPrice }));
            } else if (membershipType.name === 'General Member (NO Balavihar)') {
                setTempData((prevData) => ({ ...prevData, membershipGeneralAdmissionFee: membershipType.bvPrice }));
            } else if (membershipType.name === 'Balavihar (Single Child)') {
                setTempData((prevData) => ({ ...prevData, membershipSingleChildFee: membershipType.bvPrice }));
            } else if (membershipType.name === 'Balavihar (2+ Children)') {
                setTempData((prevData) => ({ ...prevData, membershipTwoPlusChildFee: membershipType.bvPrice }));
            } else if (membershipType.name === 'Chinmaya Parivar (NO Balavihar)') {
                setTempData((prevData) => ({ ...prevData, membershipParivarNoBalaviharFee: membershipType.bvPrice }));
            }
        });
        

    };
    const checkoutHandler = (e) => {
        e.preventDefault();
        setError(null);
        loadMembershipData();
        //membershipData.currentTransaction.totalAmount = 0;
        // Skip payment if total amount is zero
        if (totalAmount >0 ) {        
            membershipData.status = "pending";
        } else {
            membershipData.status = "paid";
            setSuccess(true); // Skip payment if total amount is zero
        }

        //    console.log("transaction before sent to SQS:", (inputFields));
        if (sendToServer()) {
            console.log("checkout true");
            //setCheckout(true);
        } else {
            //setCheckout(false);
            console.log("checkout false");
        }
    };
    async function sendToServer() {
        console.log("transaction before sent to Database:", membershipData);
        const maxRetries = 3; // Maximum number of retries
        let attempt = 0;

        while (attempt < maxRetries) {
            try {
            //const url = process.env.REACT_APP_SQS_URL;
            const response = await fetch(`${API_URL}/memberships`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "x-cmdfw-jwt-token": `${accessToken}`,
                },
                body: JSON.stringify(membershipData),
            });
            console.log('API response:', response.data);
            if (response.ok) {
                setCheckout(true);
                return true; // Success
            }
            if (response.status === 403) {
                const errorData = await response.json();
                handleLogout(); // Logout user
                throw new Error(errorData.message || 'OTP expired');
              } else {
                const errorData = await response.json();
                console.error('API Error:', errorData);
                setError(errorData.message);
                return false; // API call failed
                //throw new Error(errorData.message || 'API call failed');
            }
        } catch (error) {
            console.error(`Attempt ${attempt + 1} failed:`, error);
            attempt++;

            if (attempt >= maxRetries) {
                console.error('All retry attempts failed.');
                setCheckout(false);
                setError("Failed to send data to the server. Please try again later.");
                return false; // Return false after all retries fail
            }

            console.log(`Retrying API call... (${attempt}/${maxRetries})`);
 
        }
    }
    }

    function peopleSwitchHandler(e) {
        console.log("switch handler :", e.target.checked);

        handleAddFields();
        //setAddPeople(e.target.checked);
    };

    function feeSwitchHandler(e) {
        setFeeEnabled(e.target.checked);
        eventData.feeEnabled = e.target.checked ;
        //console.log("Event data feeSwitchHandler :", (eventData.feeEnabled));
    }
    function parivarSwitchHandler(e) {
        setParivarEnabled(e.target.checked);
        eventData.parivarEnabled = e.target.checked ;
    }

    function handleBack() {
        setCheckout(false);
    }

    function handleDonation(e) {
        setInputFields({ ...inputFields, [e.target.name]: parseInt(e.target.value) });
        if (e.target.value >= 0) {
            setDonation(parseInt(e.target.value));
        }
    };

    const handleCancel = () => {
        navigate('/EventTypesForm');
        // Add any additional save logic here, such as API calls
      };
    
 
    const [success, setSuccess] = useState(false)
    const [checkout, setCheckout] = useState(false)


    return (
        <div>
            <Grid item xs={12} sm={12}>
                    <Typography variant="h6" align="center" gutterBottom>
                        {'CMDFW Registration System'}
                    </Typography>
                </Grid>

            <form onSubmit={checkoutHandler}>
                <Grid container direction="column" alignItems="center" >
                    {
                        checkout ?
                            success  ?
                                <Grid item>
                                    <img src={successIcon} className="Success-icon" alt="logo" />
                                    <Typography variant="h5" align="center" gutterBottom>
                                        {'Thank You for the Registration'}
                                    </Typography>
                                    <Box sx={{ width: '100%', maxWidth: 500 }}>
                                        <Typography variant="body2" align="left" gutterBottom>
                                            You will receive an email confirmation to this address <b> [ {eventData.parent.email} ] </b>
                                        </Typography>
                                    </Box>
                                </Grid>
                                :
                                
                                <Grid item>
                                    <PaymentComp eventData={eventData} setSuccess={setSuccess} membershipData={membershipData}/>
                                    <span>
                                        <Button type="submit" variant="contained" sx={{ mt: 3, mb: 2 }} onClick={() => handleBack()}>Back</Button>
                                    </span>
                                </Grid>
                            :
                            <div>
                                <Grid item xs={12} sm={12}>
                                <Paper elevation={3}>
                                <Paper style={{ padding: '16px', backgroundColor: '#dfe7e7', color: 'black' }} elevation={3}>
                                    <Grid item>
                                        <Box sx={{ width: '100%', minWidth: 300 }}>
                                            <Typography variant="body2" align="left" gutterBottom>

                                                <div><b>Event:</b> Balavihar Registration</div>
                                                <div><b>When: </b>{memberships.balaviharPeriod}</div>
                                                <b>Membership Fee: </b><b>One Child: </b> ${Math.round(tempData.membershipSingleChildFee)}, <b>Two or more Children: </b> ${Math.round(tempData.membershipTwoPlusChildFee)}, 
                                                <b>Parivar: </b> ${Math.round(tempData.membershipParivarMemberFee)}, <b>General Admission or No Children: </b> ${Math.round(tempData.membershipGeneralAdmissionFee)} <br />
                                                <div><br /></div>
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    </Paper>
                                    </Paper>
                                </Grid>
                                <div><br /></div>
                                <Grid item xs={12} sm={12}>
                                {
                                    memberships.status === "ACTIVE" ?
                                        (
                                        <div>
                                        <div>Membership status is <b>Active</b> for the period: <b>{memberships.balaviharPeriod}</b></div>
                                        <div>Membership Type : <b>{memberships.currentMembership.membershipTypesEntity.name}</b></div>
                                        <div><br /></div>
                                        </div>
                                        )

                                        :
                                        
                                        (
                                        <div><b>Membership expired.</b> 
                                        <div><b>RENEW</b> the membership for the period: <b>{memberships.balaviharPeriod}</b></div>
                                        <div><br /></div>

                                        <FormControl variant="standard" sx={{ m: 1, minWidth: 200 }} size="small">
                                        <InputLabel id="demo-simple-select-standard-label">Select membership type</InputLabel>
                                        <Select
                                            id="standard"
                                            required
                                            name="membershipType"
                                            value={tempData.membershipType}
                                            onChange={e => setTempData({ ...tempData, [e.target.name]: e.target.value })}
                                            label="Center"
                                        >
                                            <MenuItem value="Balavihar">Balavihar with Children</MenuItem>
                                            <MenuItem value="GeneralAdmission">General Member (NO Balavihar)</MenuItem>                                           

                                        </Select>
                                    </FormControl>
                                    </div>
                                        )
                                        }                           
                                    
                                
                                </Grid>
                                

                                <Grid item xs={12} sm={12}>
                                {
                                tempData.membershipType === "Balavihar" || memberships.status === "ACTIVE" ? 
                                    <Grid container alignItems="center" >
                                        
                                    <Paper elevation={3}>
                                        <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
                                        <Typography variant="h7" align="left" gutterBottom>
                                            <b>Balavihar Participant Information</b>
                                        </Typography>
                                        </Paper>
                                        <div><br /></div>
                                        <Grid container justifyContent="center" alignItems="center" >
                                            <Grid item>
                                            {studentFields.length === 0 && (
                                                <FormGroup>
                                                <FormControlLabel control={<Switch />} label="Add Balavihar Children" size="small" onChange={peopleSwitchHandler} />
                                                </FormGroup>
                                            )}
                                            </Grid>
                                        </Grid>   
                                  
                                        
                                        <div><br /></div>
                                        <Grid item xs={12} sm={12}>
                                            <Grid container align="left" >
                                                {studentFields && studentFields.map((studentFields, index) => (
                                                    <div key={index} align="left">
                                                        <Grid container spacing={2} >
                                                            
                                                            <Grid item xs={12} sm={6}>                                                            
                                                                <FormControl variant="outlined" sx={{ m: 1, minWidth: 240 }} size="normal">
                                                                    <InputLabel id="demo-simple-select-standard-label">Full Name</InputLabel>
                                                                    <Select
                                                                        required
                                                                        id="standard"
                                                                        name="fullName"
                                                                        fullwidth
                                                                        value={studentFields.fullName}
                                                                        onChange={(e) => handleStudentChange(e, index)}
                                                                        label="fullName"
                                                                    >
                                                                        {getAvailableChildren(index).map((item, index) =>
                                                                        <MenuItem key={index} value={item}>{item}</MenuItem>
                                                                        )}                                                                        
                                                                    </Select>
                                                                </FormControl>                                                              
                                                            </Grid>                                                           
                                                            
                                                            <Grid item xs={12} sm={6}>                                                            
                                                                <FormControl variant="outlined" sx={{ m: 1, minWidth: 240 }} size="normal">
                                                                    <InputLabel id="demo-simple-select-standard-label">Session</InputLabel>
                                                                    <Select
                                                                        required
                                                                        id="standard"
                                                                        name="session"
                                                                        fullwidth
                                                                        value={studentFields.session}
                                                                        onChange={(e) => handleSessionChange(e, index)}
                                                                        label="session"
                                                                    >
                                                                        {sessions.map((item, index) =>
                                                                        <MenuItem key={index} value={item}>{item}</MenuItem>
                                                                        )}                                                                        
                                                                    </Select>
                                                                </FormControl>                                                              
                                                            </Grid>
                                                            
                                                            <Grid item xs={12} sm={6}>
                                                            <Paper elevation={0}> 
                                                                <FormControl variant="outlined" sx={{ m: 1, minWidth: 240 }} size="normal">
                                                                    <InputLabel id="demo-simple-select-standard-label">Grade</InputLabel>
                                                                    <Select
                                                                        required
                                                                        id="grade"
                                                                        name="grade"
                                                                        value={studentFields.grade}                                                                        
                                                                        onChange={(e) => handleStudentChange(e, index)}
                                                                        label="grade"
                                                                    >                                                                        
                                                                        {grades.map((item, index) =>
                                                                        <MenuItem key={index} value={item}>{item}</MenuItem>
                                                                        )} 
                                                                    </Select>
                                                                </FormControl>
                                                                </Paper>
                                                            </Grid>                                                   
                                                            
                                                            <div><br /></div>
                                                            
                                                            <Grid item xs={12} sm={12}>
                                                                <div><br /></div>                                                                
                                                                <Paper elevation={3} variant="outlined">
                                                                {// Display the Add/Delete buttons only if the membership is not active
                                                                }      
                                                                {memberships.status === "ACTIVE" ?
                                                                    <b>Add Additional Participant  : </b> :
                                                                <b>Add/Delete Additional Participant  : </b>
                                                                }                   
                                                                {memberships.status !== "ACTIVE" ?
                                                                    <IconButton onClick={() => handleRemoveFields(index)}>
                                                                        <DeleteIcon />
                                                                    </IconButton> : ''
                                                                }
                                                                <IconButton onClick={() => handleAddFields(index)}>
                                                                    <PersonAddIcon />
                                                                </IconButton>
                                                                    
                                                                </Paper>
                                                            </Grid>
                                                        </Grid>
                                                    </div>
                                                ))}
                                                {error && (
                                                    <Grid item xs={12}>
                                                        <Alert severity="error">{error}</Alert>
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </Grid>
                                        </Paper>
                                    </Grid>
                                    : "" }

                                </Grid>
                                                                                       
                                                         
                                <div><br /></div>
                                <Paper elevation={3}>
                                        <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
                                        <Typography variant="h7" align="left" gutterBottom>
                                            <b>Payment Information</b>
                                        </Typography>
                                </Paper>
                                <div><br /></div>
                                <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            disabled
                                            id="FeeAmountPaid"
                                            label="Balavihar Fee Paid Amount($)"
                                            type="number"
                                            name="feeAmountPaid"
                                            variant="standard"
                                            value={memberships.totalAmountPaid}
                                        />
                                    </Grid>

                                <Grid item xs={12} sm={12}>
                                        <FormGroup>
                                            <FormControlLabel control={<Checkbox checked={parivarEnabled} disabled={parivarMember} />} label={`${tempData.membershipParivarMemberFee} (Upgrade to Parivar membership)`}
                                                value={parivarEnabled} size="small" onChange={parivarSwitchHandler} />
                                        </FormGroup>
                                    </Grid>
                                <div><br /></div>
                                <Grid container direction="row" spacing={2} >
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            number
                                            id="donation"
                                            label="Additional Donation ($)"
                                            type="number"
                                            name="donation"
                                            variant="standard"
                                            value={donation}
                                            onChange={handleDonation}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FormGroup>
                                            <FormControlLabel control={<Checkbox checked={feeEnabled} />} label="Add 3% to cover for CC fees"
                                                value={feeEnabled} size="small" onChange={feeSwitchHandler} />
                                        </FormGroup>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <TextField
                                            fullWidth
                                            disabled
                                            id="totalAmountField"
                                            label="Total Amount($)"
                                            type="number"
                                            name="totalAmount"
                                            variant="standard"
                                            inputProps={{ style: { fontSize: 20 } }} // font size of input text
                                            InputLabelProps={{ style: { fontSize: 20 } }} // font size of input label
                                            value={totalAmount}
                                        />
                                    </Grid>
                                </Grid>
                                </Paper>

                                <div><br /></div>
                                <Grid container direction="row" spacing={5}>
                                    <Grid item>
                                        <Typography variant="body2" align="center" gutterBottom>
                                        <b>Waiver Statement (Please read and agree to the waiver statement before you proceed) :</b> <a href="https://membership.cmdfw.org/docs/cmdfw-waiver.pdf" target="_blank" rel="noopener noreferrer"> Open PDF </a>
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid container direction="row" spacing={5}>
                                    <Grid item>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={rulesAccepted}
                                                    onChange={(e) => setRulesAccepted(e.target.checked)}
                                                    name="rulesAccepted"
                                                    color="primary"
                                                />
                                            }
                                            label="I accept the rules and policies"
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container direction="row" spacing={2}>
                                    
                                    <Grid item>
                                        <Button onClick={handleCancel} variant="contained" sx={{ mt: 3, mb: 2 }}>Cancel</Button>
                                    </Grid>
                                    <Grid item>
                                    <Tooltip title={!rulesAccepted ? "Please accept the rules and policies" : ""}>
                                        <span>
                                        <Button type="submit" variant="contained" sx={{ mt: 3, mb: 2 }} disabled={!rulesAccepted}>Checkout</Button>
                                        </span>
                                    </Tooltip>
                                    </Grid>
                                    {error && (
                                        <Grid item xs={12}>
                                            <Alert severity="error">{error}</Alert>
                                        </Grid>
                                    )}
                                </Grid>
                                    <Grid container direction="row" spacing={5}>
                                    <Grid item>
                                        <Typography variant="body2" align="center" gutterBottom>
                                            If you have any questions, please contact us at <a href="mailto:membership@cmdfw.org">membership@cmdfw.org</a>
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </div>
                    }
                </Grid>
            </form>
        </div >
    );
}